// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The switch - the box around the slider */
.switch {
   position: relative;
   display: inline-block;
   width: 50px;
   height: 20px;
   margin: auto 0;
}

/* Hide default HTML checkbox */
.switch input {
   opacity: 0;
   width: 0;
   height: 0;
}

/* The slider */
.slider {
   position: absolute;
   cursor: pointer;
   top: 0;
   left: 0;
   right: 0;
   bottom: 0;
   background-color: var(--button-primary);
   transition: .4s;
}

.slider:before {
   position: absolute;
   content: "";
   height: 80%;
   width: 22px;
   left: 4px;
   bottom: 2px;
   background-color: var(--true-white);
   transition: .4s;
}

/* Active State */
.active .slider {
   background-color: var(--button-primary-clicked);
}

.active .slider:before {
   transform: translateX(20px);
}

/* Rounded sliders */
.slider.round {
   border-radius: var(--border-radius);
}

.slider.round:before {
   border-radius: var(--border-radius);
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLInputs/ECLSwitch/ECLSwitch.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;GACG,kBAAkB;GAClB,qBAAqB;GACrB,WAAW;GACX,YAAY;GACZ,cAAc;AACjB;;AAEA,+BAA+B;AAC/B;GACG,UAAU;GACV,QAAQ;GACR,SAAS;AACZ;;AAEA,eAAe;AACf;GACG,kBAAkB;GAClB,eAAe;GACf,MAAM;GACN,OAAO;GACP,QAAQ;GACR,SAAS;GACT,uCAAuC;GACvC,eAAe;AAClB;;AAEA;GACG,kBAAkB;GAClB,WAAW;GACX,WAAW;GACX,WAAW;GACX,SAAS;GACT,WAAW;GACX,mCAAmC;GACnC,eAAe;AAClB;;AAEA,iBAAiB;AACjB;GACG,+CAA+C;AAClD;;AAEA;GACG,2BAA2B;AAC9B;;AAEA,oBAAoB;AACpB;GACG,mCAAmC;AACtC;;AAEA;GACG,mCAAmC;AACtC","sourcesContent":["/* The switch - the box around the slider */\r\n.switch {\r\n   position: relative;\r\n   display: inline-block;\r\n   width: 50px;\r\n   height: 20px;\r\n   margin: auto 0;\r\n}\r\n\r\n/* Hide default HTML checkbox */\r\n.switch input {\r\n   opacity: 0;\r\n   width: 0;\r\n   height: 0;\r\n}\r\n\r\n/* The slider */\r\n.slider {\r\n   position: absolute;\r\n   cursor: pointer;\r\n   top: 0;\r\n   left: 0;\r\n   right: 0;\r\n   bottom: 0;\r\n   background-color: var(--button-primary);\r\n   transition: .4s;\r\n}\r\n\r\n.slider:before {\r\n   position: absolute;\r\n   content: \"\";\r\n   height: 80%;\r\n   width: 22px;\r\n   left: 4px;\r\n   bottom: 2px;\r\n   background-color: var(--true-white);\r\n   transition: .4s;\r\n}\r\n\r\n/* Active State */\r\n.active .slider {\r\n   background-color: var(--button-primary-clicked);\r\n}\r\n\r\n.active .slider:before {\r\n   transform: translateX(20px);\r\n}\r\n\r\n/* Rounded sliders */\r\n.slider.round {\r\n   border-radius: var(--border-radius);\r\n}\r\n\r\n.slider.round:before {\r\n   border-radius: var(--border-radius);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
